import * as React from "react";
import SideNavigation from "@amzn/awsui-components-react/polaris/side-navigation";
import Header from "@amzn/awsui-components-react/polaris/header";
import Box from "@amzn/awsui-components-react/polaris/box";
import PageShell from "../../../../global/components/PageShell";
import CopayHardshipWaiverSection from "./CopayHardshipWaiverSection";

interface State {
  navOpen: boolean;
}

class CopayWaiverPage extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = { navOpen: true };
  }

  render() {
    return (
      <PageShell
        navigationOpen={this.state.navOpen}
        onNavigationChange={(open) => this.setState({ navOpen: open })}
        navigation={
          <SideNavigation
            header={{ text: "Copay Waiver", href: "#execute-copay-waiver" }}
            activeHref="#execute-copay-waiver"
            items={[
              {
                type: "section",
                text: "Copay Waiver",
                items: [{ type: "link", text: "Execute Copay Waiver", href: "#execute-copay-waiver" }],
              },
            ]}
          />
        }
        content={
          <div>
            <Box padding={{ top: "l", bottom: "l" }}>
              <Header
                variant="h1"
                description="Execute a Medicaid copay hardship waiver on a PENDING fill for a test customer"
              >
                Copay Waiver
              </Header>
            </Box>
            <CopayHardshipWaiverSection />
          </div>
        }
      />
    );
  }
}

export default CopayWaiverPage;
